const logoCls = "_61l1kzjus3";
const publisherLogoCls = "_61p16aw8fw";
const portalLogoCls = "_61pgfdjig";

export { logoCls, portalLogoCls, publisherLogoCls };
import "./Logo.style.linaria.module.css";
//# sourceMappingURL=Logo.style.js.map
